// extracted by mini-css-extract-plugin
module.exports = {"popup-tw":"PopupTW_popup-tw__3Hk8s"};